// extracted by mini-css-extract-plugin
export default {"addressSection":"eT-z","disabled":"fT-z","sectionButtons":"gT-z","logo":"hT-z"};